export function initMagnetic() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll('[data-magnetic]').forEach((el) => {
        const strength = Number(el.getAttribute('data-magnetic-strength')) || 0.12;

        const onMove = (e) => {
            const r = el.getBoundingClientRect();
            const x = (e.clientX - (r.left + r.width / 2)) * strength;
            const y = (e.clientY - (r.top + r.height / 2)) * strength;
            el.style.setProperty('--mag-x', `${x.toFixed(2)}px`);
            el.style.setProperty('--mag-y', `${y.toFixed(2)}px`);
        };
        const onLeave = () => {
            el.style.setProperty('--mag-x', '0px');
            el.style.setProperty('--mag-y', '0px');
        };

        el.addEventListener('mousemove', onMove);
        el.addEventListener('mouseleave', onLeave);
    });
}
